import _axios from "../../apiClient";

export function getInstalacion(payload) {
  return _axios
    .get(
      `/api/Instalacion/Get`,
      {
        params: { url: payload },
      },
      {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function getUsuarioLogeado() {
  return _axios
    .get(`/api/Usuario/CurrentUser`, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function autenticarUsuario(payload) {
  return _axios
    .post(`/api/Usuario/Autenticar`, payload, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function restablecerContrasenia(payload) {
  return _axios
    .post(`/api/Usuario/RestablecerContrasenia`, payload, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function olvidoContrasenia(payload) {
  return _axios
    .post(`/api/Usuario/OlvidoContrasenia`, payload, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function validarCodigo(payload) {
  return _axios
    .post(`/api/Usuario/ValidarCodigo`, payload, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function logOutUsuario() {
  return _axios
    .post(`/api/Usuario/logOutUsuario`, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function getImagenLogin(payload) {
  return _axios
    .get(
      `/api/Instalacion/GetImagenLogin`,
      {
        params: { idInstalacion: payload },
      },
      {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function setMontoCompraMinima(payload) {
  return _axios
    .get(
      `/api/Instalacion/SetMontoCompraMinima`,
      {
        params: { monto: payload.monto, idInstalacion: payload.idInstalacion },
      },
      {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function setConfiguracionDelivery(payload) {
  return _axios
    .get(
      `/api/Instalacion/SetConfiguracionDelivery`,
      {
        params: {
          cobroDelivery: payload.cobroDelivery,
          monto: payload.monto,
          idInstalacion: payload.idInstalacion,
        },
      },
      {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function setConfiguracionDeliveryBonificado(payload) {
  return _axios
    .get(
      `/api/Instalacion/SetConfiguracionDeliveryBonificado`,
      {
        params: {
          deliveryBonificado: payload.deliveryBonificado,
          monto: payload.monto,
          idInstalacion: payload.idInstalacion,
        },
      },
      {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function setNuevaClavePicking(payload) {
  return _axios
    .put(
      `/api/Instalacion/AdminNewPasword`,

      payload,

      {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function setGetClavePicking(payload) {
  return _axios
    .get(
      `/api/Instalacion/AdminPassword`,

      payload,

      {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}
export const getEstilosInterno = async () => {
  try {
    const response = await _axios.get(`/api/Estilos/interno`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener estilos internos:", error);
    throw error;
  }
};

export const saveEstilosInterno = async (estilos) => {
  try {
    const response = await _axios.post(`/api/Estilos/interno`, estilos);
    return response.data;
  } catch (error) {
    console.error("Error al guardar estilos internos:", error);
    throw error;
  }
};

export const getEstilosOnline = async () => {
  try {
    const response = await _axios.get(`/api/Estilos/online`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener estilos online:", error);
    throw error;
  }
};

export const saveEstilosOnline = async (estilos) => {
  const response = await _axios.post(`/api/Estilos/online`, estilos);
  return response.data;
};

export const saveInstalacion = async (instalacionData) => {
  let formDataToSend;

  if (instalacionData instanceof FormData) {
    formDataToSend = instalacionData;
  } else {
    formDataToSend = new FormData();

    // Agregar archivos al FormData
    for (const key in instalacionData) {
      if (instalacionData[key] instanceof File) {
        formDataToSend.append(key, instalacionData[key]);
      } else if (key === "datosContacto") {
        // Convertir DatosContacto a JSON
        formDataToSend.append("DatosContacto", JSON.stringify(instalacionData[key]));
      } else {
        formDataToSend.append(key, instalacionData[key]);
      }
    }
  }

  const response = await _axios.post("api/Instalacion/instalacion", formDataToSend, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
